module.exports = __webpack_public_path__ + "static/img/LeadSmart-logo-standard.2b2bf25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/update/LeadSmart-logo-standard.png
// module id = 10Ok
// module chunks = 1